<template>
  <div class="loginpage">
    <div class="loginBox">
      <div class="login-content">
        <div class="login-left">
          <div class="title2" style="
              font-size: 38px;
              margin-top: 55px;
              text-align: center;
              padding-left: 0;
            ">
            心海蓝韵<br /><span style="font-size: 22px">蓝韵心理咨询服务平台</span>
          </div>
          <img width="300px" style="margin-left: 83px" src="/static/images/ly_logo.png" alt="" />
        </div>
        <div class="login-right">
          <div class="title3">用户登录 / Login</div>
          <div class="log-row">
            <div style="margin-bottom: 10px">
              <span class="title4">用户名</span>
              <span class="title5">/ Username</span>
            </div>
            <el-input class="input-style userName" v-model="loginInfo.UserName" @on-enter="uiLogin" type="text"
              :value="loginInfo.UserName" placeholder="请输入用户名" />
          </div>
          <div class="log-row">
            <div style="margin-bottom: 10px">
              <span class="title4">密码</span>
              <span class="title5">/ Password</span>
            </div>
            <el-input class="input-style userPwd" v-model="loginInfo.PassWord" @on-enter="uiLogin" type="password"
              :value="loginInfo.PassWord" placeholder="请输入密码" />
          </div>
          <div class="log-row">
            <el-button class="input-style btn" type="primary" @click="uiLogin">登 录
            </el-button>
          </div>
        </div>
      </div>
      <div class="bottom-text">
        <p>
          <a target="_bank" href="http://www.beian.miit.gov.cn">蜀ICP备20012822号-4</a>
        </p>
        <p>
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=51010702042932" rel="noreferrer" target="_blank"><img
              style="height: 20px; margin-right: 6px; margin-bottom: -4px"
              src="/static/images/备案图标.png">川公网安备51010702042932</a>
        </p>
        <p>
          <a href="http://www.bluerhyme.net/" target="_bank"><img
              style="height: 20px; margin-right: 6px; margin-bottom: -4px"
              src="/static/images/logo.png" />四川蓝韵心理咨询服务有限公司</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// let ipInfo = returnCitySN;
export default {
  name: "login",
  data() {
    return {
      loginInfo: {
        UserName: "",
        PassWord: "",
        Channel: 3,
        IDCARD: "",
        Channel: 2,
        cip: null,
        cname: "",
      },
      remenber: false,
    };
  },
  created() { },
  methods: {
    // 获取用户ip 信息
    getUserIpInfo(userInfo) {
      this.$axios.post("newSysSvr/psychological/log/loginLog", {
        avatar: userInfo.AVATAR,
        displayName: userInfo.DISPLAY_NAME,
        userId: userInfo.USER_ID,
        userName: userInfo.USER_NAME,
        systemType: "pc", //手机系统
        phoneModel: "电脑", // 手机品牌
        phone: userInfo.MOBILE, // 手机号
        registerType: '系统注册', // 授权类型
        loginIp: window.ipJson.ip,
      });
      // this.$axios.post({
      //   svrId: "newSysSvr",
      //   url: "psychological/log/loginLog",
      //   IsNeedToken: false,
      //   data: {
      //     avatar: userInfo.AVATAR,
      //     displayName: userInfo.DISPLAY_NAME,
      //     userId: userInfo.USER_ID,
      //     userName: userInfo.USER_NAME,
      //     systemType: "pc", //手机系统
      //     phoneModel: "电脑", // 手机品牌
      //     phone: userInfo.MOBILE, // 手机号
      //     registerType: null, // 授权类型
      //   },
      // });
    },
    uiLogin() {
      this.$axios
        .post("sysSvr/User/Login", {
          userInfoDto: this.loginInfo,
        })
        .then((res) => {
          if (res.code == 200 || res.code == 0) {
            this.getUserIpInfo(res.data); // 记录登录ip
            window.sessionStorage.setItem("token", res.data.Token);
            window.sessionStorage.setItem("userInfo", JSON.stringify(res.data));
            // 系统管理员角色权限
            if (res.data.ROLE_ID == 1) {
              this.$message.success("登录成功！");
              this.$router.push("/home");
            }
            // 入驻平台咨询师登录--方便运维回复聊天消息
            else if (res.data.ROLE_ID == 3) {
              window.sessionStorage.setItem("token", res.data.Token);
              window.sessionStorage.setItem(
                "userInfo",
                JSON.stringify(res.data)
              );
              this.$router.push("/psychiatristChat");
            }
          } else {
            this.$message.error("登录失败！" + res.data);
          }
        });
    },
  },
};
</script>

<style scoped>
.loginpage {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: #eef3fa;
  height: 100%;
  width: 100%;
  z-index: 1000;
}

.loginBox {
  position: absolute;
  left: 50%;
  min-width: 1658px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
  background-image: url("/static/images/login_bg1.png");
  background-size: cover;
}

.topImg img {
  width: 100%;
  height: 100%;
}

.login-content {
  width: 960px;
  height: 540px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  -webkit-border-radius: 5px;
  -ms-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  box-shadow: 0 0 20px rgba(12, 82, 126, 1);
}

.login-left {
  float: left;
  width: 49%;
  height: 100%;
  background-image: url("/static/images/login_bg2.png");
  border-radius: 5px 0 0 5px;
  /*padding: 10px;*/
}

.login-right {
  float: left;
  width: 44%;
  margin: 30px;
}

.title1 {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
  font-size: 48px;
  color: #ffffff;
  padding: 30px 30px 0 30px;
  text-align: left;
}

.title2 {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  color: #ffffff;
  padding-left: 165px;
}

.title3 {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
  color: #01058a;
  font-size: 32px;
  padding: 25px 0 10px 10px;
}

.title4 {
  font-family: "微软雅黑 Bold", "微软雅黑";
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  color: #01058a;
}

.title5,
.forget_pwd {
  color: #918d9a;
  font-family: "Arial Normal", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  cursor: pointer;
}

.forget_pwd:hover {
  color: #01058a;
}

.log-row {
  padding: 30px 10px 10px 10px;
}

.log-row {
  width: 410px !important;
}

.input-style {
  width: 410px;
  border: none;
}

.btn {
  /*margin-top: 24px;*/
  font-weight: 700;
  font-size: 18px;
  height: 48px;
  background-color: #091d7c !important;
  border-color: #091d7c !important;
}

.bottom-text {
  width: 100%;
  position: absolute;
  bottom: 1%;
  text-align: center;
  font-size: 14px;
}

.bottom-text a {
  color: #ffffff;
  text-decoration: none;
}

/deep/ .el-input__inner {
  height: 48px;
  border: none;
  border-bottom: 2px solid #dcdfe6;
  border-radius: 0px;
}

/deep/ .el-radio__inner {
  width: 18px !important;
  height: 18px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue